export default __webpack_public_path__ + "static/media/city-population-more.9b6a396a.svg";